import Vue from 'vue';

export default Vue.mixin({
  data() {
    return {
      darkMode: false,
      languages: ['hu-HU', 'en-EN', 'de-DE'],
      publicPath: process.env.BASE_URL,
    };
  },
  methods: {
    detectLanguage() {
      if (!localStorage.getItem('language')) {
        localStorage.setItem('language', navigator.language);
        const lang = localStorage.getItem('language');
        if (lang === 'hu' || lang === 'hu-HU') {
          this.$i18n.locale = 'hu-HU';
        } /*else if (lang === 'en' || lang === 'en-EN') {
          this.$i18n.locale = 'en-EN';
        } else if (lang === 'de' || lang === 'de-DE') {
          this.$i18n.locale = 'en-EN';
        }*/ else {
          this.$i18n.locale = 'hu-HU';
        }
      } else {
        const lang = localStorage.getItem('language');
        if (lang === 'hu' || lang === 'hu-HU') {
          this.$i18n.locale = 'hu-HU';
        } /*else if (lang === 'en' || lang === 'en-EN') {
          this.$i18n.locale = 'en-EN';
        } else if (lang === 'de' || lang === 'de-DE') {
          this.$i18n.locale = 'en-EN';
        }*/ else {
          this.$i18n.locale = 'hu-HU';
        }
      }
    },
    changeLanguage(lang) {
      if (this.languages.includes(lang)) {
        localStorage.setItem('language', lang);
        this.$i18n.locale = lang;
      }
    },
  },
});
